import React from 'react'

import { RadioGroup } from '@components'
import { DINING_METHOD_OPTIONS } from '@common'
import { useUserRedux } from '@hooks'

import Selector from './Selector'

const DiningMethodSelector = ({ mode, value, onChange, containerClassName }) => {
    const { diningMethod } = useUserRedux()

    if (mode === 'Dropdown') {
        return (
            <Selector
                value={value || diningMethod}
                defaultValue={diningMethod}
                options={DINING_METHOD_OPTIONS}
                onChange={onChange}
                textHeader="Dining Preference"
                containerClassName={containerClassName}
                isSearchable={false}
            />
        )
    }

    if (mode === 'RadioGroup') {
        return (
            <RadioGroup
                value={value || diningMethod.value}
                defaultValue={diningMethod.value}
                options={DINING_METHOD_OPTIONS}
                textHeader={'Dining Preference'}
                onChange={onChange}
                containerClassName={containerClassName}
            />
        )
    }

    return null
}

export default DiningMethodSelector
